var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwingset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "swingset"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M27,2V4h2V6H3V4H5V2H1V30H3V8H6V26h8V8h6.5V18.12a4.5,4.5,0,1,0,2,0V8H29V30h2V2ZM24,22.5A2.5,2.5,0,1,1,21.5,20,2.5,2.5,0,0,1,24,22.5ZM8,24V22h4v2Zm4-4H8V8h4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwingset);
export default __webpack_public_path__ + "static/media/swingset.722f01c2.svg";
export { ForwardRef as ReactComponent };